"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateString = void 0;
exports.truncateString = function (str, length, ellipse) {
    if (ellipse === void 0) { ellipse = "..."; }
    return str.length > length ? "" + str.slice(0, length) + ellipse : str;
};
//# sourceMappingURL=truncate-string.js.map